import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const QRCode = styled.img `
  height: 200px;
  width: 200px;
  margin-top: 28px;
  margin-bottom: 16px;
`;
export const Links = styled.div `
  display: flex;
  gap: 16px;

  a {
    display: block;
  }

  img {
    display: block;
    height: 40px;
    width: auto;
  }
`;
